"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledButton = exports.classes = void 0;
const ButtonBase_1 = require("@mui/material/ButtonBase");
const styles_1 = require("@mui/material/styles");
const icon_button_1 = __importDefault(require("../icon-button"));
const PREFIX = "ArrowControl";
exports.classes = {
    left: `${PREFIX}-left`,
    right: `${PREFIX}-right`,
    chevron: `${PREFIX}-chevron`
};
exports.StyledButton = (0, styles_1.styled)(icon_button_1.default)({
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    boxShadow: "0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 5px 8px 0px rgba(0, 0, 0, 0.14), 0px 1px 14px 0px rgba(0, 0, 0, 0.12)",
    [`&.${ButtonBase_1.buttonBaseClasses.root}`]: {
        borderRadius: "50%"
    },
    [`&.${exports.classes.left}`]: {
        left: -20,
        transform: "translate(-50%, -50%)"
    },
    [`&.${exports.classes.right}`]: {
        right: -20,
        transform: "translate(50%, -50%)"
    },
    [`& .${exports.classes.chevron}`]: {
        width: "32px",
        height: "32px"
    }
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3R5bGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2Fycm93LWNvbnRyb2wvc3R5bGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBLHlEQUE2RDtBQUM3RCxpREFBOEM7QUFDOUMsaUVBQXdDO0FBRXhDLE1BQU0sTUFBTSxHQUFHLGNBQWMsQ0FBQztBQUVqQixRQUFBLE9BQU8sR0FBRztJQUNyQixJQUFJLEVBQUUsR0FBRyxNQUFNLE9BQU87SUFDdEIsS0FBSyxFQUFFLEdBQUcsTUFBTSxRQUFRO0lBQ3hCLE9BQU8sRUFBRSxHQUFHLE1BQU0sVUFBVTtDQUM3QixDQUFDO0FBRVcsUUFBQSxZQUFZLEdBQUcsSUFBQSxlQUFNLEVBQUMscUJBQVUsQ0FBQyxDQUFDO0lBQzdDLFFBQVEsRUFBRSxVQUFVO0lBQ3BCLEdBQUcsRUFBRSxLQUFLO0lBQ1YsU0FBUyxFQUFFLGtCQUFrQjtJQUM3QixTQUFTLEVBQ1AsZ0hBQWdIO0lBQ2xILENBQUMsS0FBSyw4QkFBaUIsQ0FBQyxJQUFJLEVBQUUsQ0FBQyxFQUFFO1FBQy9CLFlBQVksRUFBRSxLQUFLO0tBQ3BCO0lBQ0QsQ0FBQyxLQUFLLGVBQU8sQ0FBQyxJQUFJLEVBQUUsQ0FBQyxFQUFFO1FBQ3JCLElBQUksRUFBRSxDQUFDLEVBQUU7UUFDVCxTQUFTLEVBQUUsdUJBQXVCO0tBQ25DO0lBQ0QsQ0FBQyxLQUFLLGVBQU8sQ0FBQyxLQUFLLEVBQUUsQ0FBQyxFQUFFO1FBQ3RCLEtBQUssRUFBRSxDQUFDLEVBQUU7UUFDVixTQUFTLEVBQUUsc0JBQXNCO0tBQ2xDO0lBQ0QsQ0FBQyxNQUFNLGVBQU8sQ0FBQyxPQUFPLEVBQUUsQ0FBQyxFQUFFO1FBQ3pCLEtBQUssRUFBRSxNQUFNO1FBQ2IsTUFBTSxFQUFFLE1BQU07S0FDZjtDQUNGLENBQUMsQ0FBQyJ9